import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Title, Code, Actions, API, Utility, Button, Messages, Control } from 'helpers/PrintImports';
import { Client } from 'models/ClientModel';
import SignaturePad from "components/common/SignManager";
import { useSearchParams } from 'react-router-dom';

const ConsentPrint15: React.FC = () => {
  const titleName = 'Mobility Equipment Rental Agreement';
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [clientData, setClientData] = useState<Client>({});
  const [signData, setSignData] = useState<string>('');
  const [receiverName, setReceiverName] = useState<string>('');
  const [receiverPhone, setReceiverPhone] = useState<string>('');

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const today = Utility.Date.Current();

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyName = Utility.Storage.CompanyName();
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  useEffect(() => {
    if(!clientId) return;
    API.Data.GetByKeyId<Client>(formName, clientId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setClientData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      setReceiverName(Utility.Get.FullName(data,Code.Form.Name.CLIENT))
      setReceiverPhone(data.client_phone || '')
    }})
    setLoading(false);
  }, []); 

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={'Form'} Privilege={Privilege} clientData={clientData} fileName={titleName} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <Control.Flex>
              <Control.Column size={[0,40,0,0]}>
                <Control.Box>
                  <Field.CompanyHead companyId={companyId} locationId={locationId} />
                </Control.Box>
              </Control.Column>
              <Control.Column size={[0,60,0,0]} align={Code.Align.RIGHT}>
                <Control.Box>
                  <Field.SubHead title={titleName} />
                </Control.Box>
              </Control.Column>
            </Control.Flex>
            <div className="content-consent">
              <p><strong>Renter</strong></p>
              <div className='print-blank'>
                <div className='print-list'>
                  <div className={`flcol form-col10`}>Name:</div>
                  <div className={`flcol form-col90 pbbottom`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col10`}>Name:</div>
                  <div className={`flcol form-col90 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col10`}>Address:</div>
                  <div className={`flcol form-col90 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col25`}>City / Province / Postal code:</div>
                  <div className={`flcol form-col75 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col10`}>Phone:</div>
                  <div className={`flcol form-col20 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col10 pl3`}>Phone:</div>
                  <div className={`flcol form-col20 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col10 pl3`}>Fax:</div>
                  <div className={`flcol form-col20 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col15`}>Email address:</div>
                  <div className={`flcol form-col50 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col35 pl3`}>for confirmation</div>
                </div>
                <div className='print-list mt2'>
                  <div className={`flcol form-col60`}>purposes Contact me about purchasing the equipment I am renting (Y/N):</div>
                  <div className={`flcol form-col15 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col20 fwb`}>Rental Period From:</div>
                  <div className={`flcol form-col20 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col10 fwb pl3 tcenter`}>To:</div>
                  <div className={`flcol form-col20 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list pt3'>
                  <div className={`flcol form-col100`}>{companyName} rents to Renter the following mobility equipment:</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col50 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col10 fwb pl3 tcenter`}>Serial#</div>
                  <div className={`flcol form-col30 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col100`}>subject to all the terms and conditions set forth in this Rental Agreement.</div>
                </div>
              </div>
              <p className="fwb">Renter covenants and agrees:</p>
              <p>
                <ol className="order-list">
                  <li>The mobility equipment shall remain the property of {companyName} during the rental period.</li>
                  <li>The renter acknowledges that, at the start of the rental period, the equipment has a retail value of $ <span className="idb lh28 pbbottom fwb cl2 px4" contentEditable>&nbsp;</span>	</li>
                  <li>The mobility equipment has been inspected by the renter and is in good condition. If the product is not clean, renter will have to pay $20 as cleaning fee</li>
                  <li>Renter will return the mobility equipment in the same condition as when received by the Renter, at the end of the rental period and shall insure that the battery in the equipment is recharged at that time.</li>
                  <li>{companyName} may repossess the mobility equipment without demand at any time if it is used in violation of the terms of this agreement.</li>
                  <li>Renter assumes all risk and liability for any loss, damage or injury, including death, to persons or property of Renter or others arising out of the use and operation of the mobility equipment during the rental period.</li>
                  <li>Renter assumes responsibility for the mobility equipment during the rental period and will reimburse {companyName} for the full cost of repair of any damage or the full cost of replacement resulting from loss, theft, or destruction of the mobility equipment while in the care of the renter. The Renter understands and authorizes {companyName} to charge the credit card of the renter used for any such repair costs or replacement costs of the mobility equipment.</li>
                  <li>
                      The renter covenants that during the rental period the mobility equipment shall not be used or operated by any person
                      <ul className="unorder-list">
                          <li>under the age of 18 or</li>
                          <li>while under the influence of intoxicants or narcotics or</li>
                          <li>in an unsafe manner</li>
                      </ul>
                  </li>
                  <li>Renter shall defend, indemnify and hold harmless {companyName} all of their agents, officers, servants, and employees from and against any and all losses, liability claims, damages, injuries, demands, actions and causes of action whatsoever, arising out of or related to any loss, damage or injury claimed by persons that may arise from the use or operation of the mobility equipment during the rental period.</li>
                  <li>{companyName} assumes no liability or responsibility for any acts or omissions of Renter or of Renter's agents, servants, or employees</li>
                  <li>Renter shall notify {companyName} immediately of any and all accidents and damage resulting from the use, operation or driving of the mobility equipment.</li>
                  <li>Renter agrees to pay all costs and expenses, including solicitor-client fees incurred by {companyName} in collecting sums due or in regaining possession of mobility equipment or in enforcing or recovering any damage, losses or claims against Renter.</li>
                  <li>Renter or the driver of the mobility equipment shall in no event be deemed the agent or employee of {companyName} in any manner or for any purpose whatsoever.</li>
                  <li>Any individual executing this Agreement as Renter in a representative capacity shall be bound personally, jointly and severally, with such fiduciary, corporation or other entity as to all obligations, expressed or implied, arising hereunder.</li>
                  <li>This Agreement shall be binding upon the heirs, next of kin, executors, administrators and personal representatives of the Renter.</li>
                  <li>If any provisions hereof or the application of any provisions to any person or circumstance is held invalid or unenforceable, the remainder hereof and the application of such provision to other persons or circumstances shall remain valid and enforceable.</li>
                  <li>Renter may cancel this order 24 hours prior to scheduled delivery of the mobility equipment, at no cost to the Renter. In the event Renter cancels this order within 24 hours of signing, Renter shall pay to {companyName} cancellation fee equal to one rental day.</li>
                  <li>Due to any reason if renter is not able to bring the stuff back his / her contract will be renewed automatically for same period over and over again unless they bring the stuff back.</li>
                </ol>
              </p>
              <div className='print-blank'>
                <div className='print-list'>
                  <div className={`flcol form-col35`}>This agreement signed by the parties at</div>
                  <div className={`flcol form-col10 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col15 pl3`}>Canada, this</div>
                  <div className={`flcol form-col10 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col10 pl3`}>Day of</div>
                  <div className={`flcol form-col10 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col5 pl3`}>2025.</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col35 fwb`}>{companyName}</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col10`}>Per:</div>
                  <div className={`flcol form-col50 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col10`}>Renter:</div>
                  <div className={`flcol form-col50 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col100`}>As security for payment required herein, the renter authorizes {companyName} to charge the renter’s credit card as may be required and contemplated herein, and provides the following information for such purpose:</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col25`}>Maximum Amount: $</div>
                  <div className={`flcol form-col15 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col80 pl3`}>being the retail value set forth in paragraph 2 hereof, in event of total loss or</div>
                </div>
                <div className='print-list'>
                    <div className={`flcol form-col100`}>failure to return equipment.</div>
                </div>
                <div className='print-list'>
                    <div className={`flcol form-col100`}>In case, you are interested in buying the equipment, 50% of the amount paid towards renting can be used for the purchase of same equipment. </div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col30`}>Visa/MasterCard/Discover #</div>
                  <div className={`flcol form-col60 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col20`}>Cardholders Name: </div>
                  <div className={`flcol form-col70 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col20`}>Expiration Date:</div>
                  <div className={`flcol form-col30 pbbottom fwb`} contentEditable>&nbsp;</div>
                  <div className={`flcol form-col20 tcenter`}>Security Code:</div>
                  <div className={`flcol form-col20 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list mt4'>
                  <div className={`flcol form-col20`}>Renter Name (Print): </div>
                  <div className={`flcol form-col70 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col20`}>Renter Signature: </div>
                  <div className={`flcol form-col70 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list'>
                  <div className={`flcol form-col30`}>Witness Name (Relation): </div>
                  <div className={`flcol form-col60 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
                <div className='print-list mb6'>
                  <div className={`flcol form-col30`}>Witness Name Signature: </div>
                  <div className={`flcol form-col60 pbbottom fwb`} contentEditable>&nbsp;</div>
                </div>
              </div>
              <p><strong>Date:</strong> {Utility.Format.Date(today,"MMMMM dd, yyyy")}</p>
            </div>
            <SignaturePad signData={signData} setSignData={setSignData} receiverName={receiverName} setReceiverName={setReceiverName} receiverPhone={receiverPhone} setReceiverPhone={setReceiverPhone} />
            
            <Field.PrintedOn />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default ConsentPrint15;